import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TableColumn } from 'types/table-column.interface';
import { API_TOOLTIP } from 'services/api.service';
import { TableComponent } from 'components/table/table.component';
import { Breadcrumb } from 'types/breadcrumb.interface';
import { BreadcrumbsComponent } from 'components/breadcrumbs/breadcrumbs.component';
import { FilterType } from 'types/table-column.interface';

@Component({
  selector: 'app-tooltip-list-page',
  standalone: true,
  imports: [TranslateModule, TableComponent, BreadcrumbsComponent],
  templateUrl: './tooltip-list-page.component.html',
  styleUrl: './tooltip-list-page.component.scss'
})
export class TooltipListPageComponent {
  public readonly apiPath = API_TOOLTIP;

  breadcrumbs: Breadcrumb[] = [
    {
      title: 'components.breadcrumbs.admin',
      url: '/'
    },
    {
      title: 'components.breadcrumbs.tooltips',
      url: '/uznirstosie-portala-padomi'
    }
  ];
  tableColumns: TableColumn[] = [
    {
      name: 'pages.tooltips.code',
      key: 'code',
      type: 'text',
      sortEnabled: true,
      filter: FilterType.Search
    },
    {
      name: 'pages.tooltips.text',
      key: 'text',
      type: 'text',
      sortEnabled: true,
      filter: FilterType.Search
    },
    {
      name: 'pages.tooltips.textEn',
      key: 'textEn',
      type: 'text',
      sortEnabled: true,
      filter: FilterType.Search
    },
    {
      name: 'pages.tooltips.description',
      key: 'description',
      type: 'text',
      sortEnabled: true,
      filter: FilterType.Search
    },
    {
      name: 'pages.tooltips.image',
      key: 'file',
      type: 'image'
    }
  ];
}
